import {
  Node_Category,
  Node_Type,
  Functionality_Base_Backend,
} from "api/GenericPathwayInterfaces";

import {
  Campaign_Pathway_Backend,
  CampaignPathwayFlow,
  CampaignNodeFlow,
  CampaignEdgeFlow,
  CampaignFunctionalityFlow,
} from "api/Campaigns/CampaignInterfaces";

/**
 * Transform backend Campaign Pathway data into frontend Flow format
 */
export function transformCampaignPathwayToFlow(
  backendData: Campaign_Pathway_Backend
): CampaignPathwayFlow {

  const nodes: CampaignNodeFlow[] = (backendData.nodes || []).map((node) => {
    const nodeTypeObj: Node_Type | null =
      typeof node.node_type === "object" ? node.node_type : null;

    const nodeCategory: Node_Category | null =
      nodeTypeObj?.node_category ?? null;

    // Convert backend functionality → frontend flow functionality
    const functionalities: CampaignFunctionalityFlow[] = (
      (node.functionalities || []) as unknown as Functionality_Base_Backend[]
    ).map((f) => ({
      id: f.id,
      name: f.name,
      description: f.description,
      inputEdgeType: f.input_edge_type,
      inputLabel: f.input_label,
      inputHandleColor: f.input_handle_colour ?? "#999999",
      outputEdgeType: f.output_edge_type,
      outputLabel: f.output_label,
      outputHandleColor: f.output_handle_colour ?? "#999999",
      label: f.label,
      metadata: f.metadata,
      valueType: f.value_type,
      valueId: f.value_id,
      value: f.value,
    }));
    
    const newNode: CampaignNodeFlow = {
      id: node.id.toString(),
      position: {
        x: node.position_x ?? 0,
        y: node.position_y ?? 0,
      },
      type: "default",
      style: {
        backgroundColor: nodeCategory?.colour_primary ?? "#999999",
        color: nodeCategory?.colour_text ?? "#FFFFFF",
      },

      // 🔥 UPDATED: people + functionality moved inside `data`
      data: {
        name: node.name,
        description: node.description ?? "",
        type: node.node_type?.name ?? "",
        category: node.node_type?.node_category?.name ?? "",
        colorPrimary: nodeCategory?.colour_primary ?? "#999999",
        linkedNode: node.node_type?.linked_node ?? false,
        linkedInteraction: node.node_type?.linked_interaction ?? null,
        linkedId: node.linked_id ?? null,
        baseLink: node.node_type?.base_link ?? "",

        people: node.people || [],
        peopleCount: node.people_count,
        addresses: node.addresses || [],
        addressesCount: node.addresses_count,
        functionalities: functionalities,
        itemTypes: node.node_type?.item_types,
      },
    };

    return newNode;
  });

  const edges: CampaignEdgeFlow[] = (backendData.edges || []).map((edge) => {
    const edgeCategory =
      typeof edge.edge_category === "object" ? edge.edge_category : null;

    return {
      id: edge.id.toString(),
      type: "standardEdge",
      source: edge.source.toString(),
      target: edge.target.toString(),
      sourceHandle: edge.source_handle,
      targetHandle: edge.target_handle,
      animated: edge.animated ?? false,
      data: {},
      style: edgeCategory
        ? {
            stroke: edgeCategory.colour_primary,
            color: edgeCategory.colour_text,
          }
        : undefined,
    };
  });

  return {
    summary: backendData.summary,
    nodes,
    edges,
  };
}
